module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-263.cb1b3a91.jpg";